import { inject, Injectable } from '@angular/core';
import { FirebaseRenderData, GroupRenderData } from './firebase.model';
import { LayerList } from '../editor/models/layer.model';
import { constructBlankRender } from './imageDraw.utils';
import { RawImageDataLoaderService } from './image-loader.service';
import { ImageDrawService } from './image-draw.service';
import { FirebaseFirestoreService } from './firebase-firestore.service';
import { Store } from '@ngrx/store';
import { BaseState } from '../reducers';
import { setRender } from '../editor/store/editor.actions';

export enum RenderType {
  'standerd',
  'group',
  'demo'
}

@Injectable({
  providedIn: 'root'
})
export class RenderDataActionsService {
  imageDataService = inject(RawImageDataLoaderService)
  imageDrawService = inject(ImageDrawService)
  firestoreService = inject(FirebaseFirestoreService)
  store = inject(Store<BaseState>)

  private async initializeRenderData(
    renderData: FirebaseRenderData,
    layerData: FirebaseRenderData['editorState'],
  ){
    const fullSizeImage = this.imageDataService.getImageSize('full')
    renderData.imageSize = [fullSizeImage.width, fullSizeImage.height]
    renderData.editorState = layerData
    renderData.lastUpdated = new Date().toISOString()
    const image = await this.imageDrawService.createThumbnailImage(layerData)
    const blob = await (await fetch(image)).blob();
    const address = await this.firestoreService.uploadThumbnailImageAndGetAddress(blob, renderData.id)
    renderData.thumbnailImage = address
    this.firestoreService.overwriteRenderData(renderData)
  }

  private async initializeGroupRenderData(
    renderData: GroupRenderData,
    layerData: FirebaseRenderData['editorState'],
    groupId: string
  ){
    const fullSizeImage = this.imageDataService.getImageSize('full')
    renderData.imageSize = [fullSizeImage.width, fullSizeImage.height]
    renderData.editorState = layerData
    renderData.lastUpdated = new Date().toISOString()
    const image = await this.imageDrawService.createThumbnailImage(layerData,true)
    const blob = await (await fetch(image)).blob();
    const address = await this.firestoreService.uploadGroupThumbnailImageAndGetAddress(blob, renderData.id, groupId)
    renderData.thumbnailImage = address
    this.firestoreService.overwriteGroupRenderData(renderData, groupId)
  }

  setGroupRenderData(renderData: GroupRenderData, groupId: string) {
    let layerData: {
      layers: LayerList,
      layerOrder: string[]
    }
    if (!renderData) {
      layerData = constructBlankRender()
    }
    else {
      if (!renderData.editorState) {
        layerData = constructBlankRender()
        this.initializeGroupRenderData(renderData, layerData, groupId)
      }
      else {
        layerData = renderData.editorState
      }
    }
    this.store.dispatch(setRender(
      {
      renderName: renderData.renderName,
      renderId: renderData.id,
      ...layerData
      }
    ))
  }

  setRenderData(renderData?: FirebaseRenderData ) {
    let layerData: {
      layers: LayerList,
      layerOrder: string[]
    }
    if (!renderData) {
      layerData = constructBlankRender()
    }
    else {
      if (!renderData.editorState) {
        layerData = constructBlankRender()
        this.initializeRenderData(renderData, layerData)
      }
      else {
        layerData = renderData.editorState
      }
    }
    this.store.dispatch(setRender(
      {
      renderName: renderData?.renderName ?? 'Demo',
      renderId: renderData?.id ?? 'Demo',
      ...layerData
      }
    ))
  }
}
